type IconProps = {
  className?: string;
};

export default function ExclamationCircle({ className }: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14C5.61553 14 4.26215 13.5895 3.11101 12.8203C1.95987 12.0511 1.06266 10.9579 0.532846 9.67879C0.00303296 8.3997 -0.13559 6.99224 0.134506 5.63437C0.404603 4.2765 1.07129 3.02922 2.05026 2.05026C3.02922 1.07129 4.2765 0.404603 5.63437 0.134506C6.99224 -0.13559 8.3997 0.00303296 9.67879 0.532846C10.9579 1.06266 12.0511 1.95987 12.8203 3.11101C13.5895 4.26215 14 5.61553 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14ZM7 1.16667C5.84628 1.16667 4.71846 1.50879 3.75918 2.14976C2.79989 2.79074 2.05222 3.70178 1.61071 4.76768C1.16919 5.83358 1.05367 7.00647 1.27876 8.13803C1.50384 9.26958 2.05941 10.309 2.87521 11.1248C3.69102 11.9406 4.73042 12.4962 5.86198 12.7212C6.99353 12.9463 8.16642 12.8308 9.23232 12.3893C10.2982 11.9478 11.2093 11.2001 11.8502 10.2408C12.4912 9.28154 12.8333 8.15373 12.8333 7C12.8333 5.45291 12.2188 3.96918 11.1248 2.87521C10.0308 1.78125 8.5471 1.16667 7 1.16667Z"
        fill="currentcolor"
      />
      <path
        d="M6.99984 7.7778C6.84575 7.77579 6.69855 7.71368 6.58959 7.60472C6.48062 7.49576 6.41852 7.34855 6.4165 7.19447V4.47225C6.4165 4.31754 6.47796 4.16917 6.58736 4.05977C6.69675 3.95037 6.84513 3.88892 6.99984 3.88892C7.15455 3.88892 7.30292 3.95037 7.41232 4.05977C7.52171 4.16917 7.58317 4.31754 7.58317 4.47225V7.19447C7.58116 7.34855 7.51905 7.49576 7.41009 7.60472C7.30113 7.71368 7.15392 7.77579 6.99984 7.7778Z"
        fill="currentcolor"
      />
      <path
        d="M6.99984 10.1112C6.84575 10.1092 6.69855 10.0471 6.58959 9.93814C6.48062 9.82917 6.41852 9.68197 6.4165 9.52789V9.139C6.4165 8.98429 6.47796 8.83591 6.58736 8.72652C6.69675 8.61712 6.84513 8.55566 6.99984 8.55566C7.15455 8.55566 7.30292 8.61712 7.41232 8.72652C7.52171 8.83591 7.58317 8.98429 7.58317 9.139V9.52789C7.58116 9.68197 7.51905 9.82917 7.41009 9.93814C7.30113 10.0471 7.15392 10.1092 6.99984 10.1112Z"
        fill="currentcolor"
      />
    </svg>
  );
}
